const TOKEN_COOKIE = "foquz_auth_token";
const TOKEN_API = "/auth/api/token";

function getToken() {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + TOKEN_COOKIE + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function setToken(token, expiresIn, domain) {
  let cookie = `${TOKEN_COOKIE}=${token}; path=/; secure; samesite=strict`;
  if (domain) cookie += `; domain=${domain}`;
  if (typeof expiresIn === "number" && expiresIn > 0) {
    cookie += `; max-age=${expiresIn}`;
  }
  document.cookie = cookie;
}

async function fetchNewToken() {
  const response = await fetch(TOKEN_API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  const data = await response.json().catch(() => null);
  const tokenData = data?.data;

  if (!response.ok || !data?.success || !tokenData?.token) {
    throw new Error("Failed to fetch auth token");
  }

  setToken(tokenData.token, tokenData.expiresIn, tokenData.domain);

  return tokenData.token;
}

function request(url, options, token) {
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function authenticatedPollApiFetch(url, options = {}) {
  let token = getToken();
  if (!token) token = await fetchNewToken();

  let response = await request(url, options, token);

  if (response.status === 401) {
    token = await fetchNewToken();
    response = await request(url, options, token);
  }

  return response;
}
